import { __awaiter, __rest } from "tslib";
import { createStore } from '@souche-f2e/muji';
import Api from '@/services';
import { judgeObj, dealCarNum, judgeEmptyStr, logColor, clearObj } from '@/shared/functions';
import { notification } from 'antd';
import { loading } from '@/components';
import { dispatch } from '@@/store';
import { isListenLong } from '@/shared/screenAndLongLinkConfig';
const initState = {
    sessionId: '',
    sessionStatus: '',
    // sessionVedioUrl: '',
    carInfo: {
        firstImage: '',
        carNum: '',
        carName: '',
        type: '',
        license: '',
        emission: '',
        address: '',
        transmission: '',
        changeNum: 0,
        mileage: '',
        onDate: '',
    },
    isFormal: false,
    isTheLast: false,
    beginPrice: '',
    carResult: 3,
    countNum: -1,
    currentPrice: '',
    answerPrice: '',
    nowCarAuctionId: '',
    countDownStatus: false,
    _count: 0,
    _loop: 0,
    bidStatus: false,
    finalOfferW: '',
    brokerageW: '',
    commissionW: '',
    exceedBasePrice: 0,
    bidType: 0,
    moreThanTender: 1,
    nextCarNum: '',
    nextCarName: '',
    is268V: false,
    rank: '',
    auctionMode: 1,
    auctionStageHasBid: false,
    biddingStage: 2,
    auctionHighestDisplay: 1,
    compareWithTenderDisplay: 1,
};
export default createStore({
    state: Object.assign({}, initState),
    effects: {
        /**
         * @desc 获取场次信息 车辆信息 竞拍信息
         */
        load(payload, { update, state, rootState }) {
            // 接口获取页面整体信息（场次|车辆|竞拍）
            const _query = rootState.router.query;
            const _param = {
                roundId: _query.id,
            };
            const { first } = payload;
            this.requestScreenDetail({ _param, first });
        },
        /**
         * @desc 请求接口
         */
        requestScreenDetail(payload, { update, state, rootState }) {
            const { _param, first } = payload;
            if (first) {
                loading.show();
            }
            Api.auction.getScreenDetail(_param).then((_r) => {
                const data = JSON.parse(JSON.stringify(_r));
                if (judgeObj(data)) {
                    const { roundId: id } = _param;
                    const { roundStatus, vedioUrl, carInfo, auctionInfo } = data, restData = __rest(data, ["roundStatus", "vedioUrl", "carInfo", "auctionInfo"]);
                    if (roundStatus === 1) {
                        this.dealNoBegin({ id, vedioUrl });
                        return;
                    }
                    if (roundStatus === 3) {
                        this.dealEnd({ id });
                        return;
                    }
                    if (roundStatus === 2 && judgeObj(carInfo) && judgeObj(auctionInfo)) {
                        this.dealBegin(Object.assign({ id, carInfo, auctionInfo }, restData));
                    }
                }
            }).finally(() => {
                if (first) {
                    loading.hide();
                }
            });
        },
        /**
         * @desc 清除定时器
         */
        resetAndclear() {
            this.CLEAR__LOOP();
            this.CLEAR__COUNT();
            this.RESET_STATE();
        },
        /**
         * @desc 清除定时器2
         */
        resetAndclear2() {
            this.CLEAR__LOOP();
            this.CLEAR__COUNT();
            this.RESET_STATE2();
        },
        /**
         * @desc 场次未开始
         */
        dealNoBegin(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                yield this.resetAndclear({});
                const { id, vedioUrl } = payload;
                this.SET_STATE({
                    sessionId: id,
                    sessionStatus: 'noBegin',
                });
            });
        },
        /**
         * @desc 场次已结束
         */
        dealEnd(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                yield this.resetAndclear({});
                // 场次结束不再轮询详情接口
                const { path } = rootState.router;
                if (path.includes('screen') && !isListenLong) {
                    // loop
                    dispatch.screenDetailLoop.stopLoop({});
                }
                const { id } = payload;
                this.SET_STATE({
                    sessionId: id,
                    sessionStatus: 'end',
                });
            });
        },
        /**
         * @desc 场次竞拍中
         */
        dealBegin(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                const { path } = rootState.router;
                yield this.resetAndclear2({});
                const { id, carInfo, auctionInfo, nextAuctionSerialNumber, nextCarName } = payload;
                const { nowCarAuctionId, firstImage: oldFirstImg } = state;
                const { auctionSerialNumber, carName, carType, license, emissionStandard, firstImage, locationName, tranmission, transferCount, mileage, factoryDate, tradeCode, reportResultType, rank, } = carInfo;
                const { roundSimulateStatus, status, theLastCar, countNum, auctionPriceW, priorityOfferW, countDownStatus, bidStatus, auctionId, finalOfferW, brokerageW, commissionW, exceedBasePrice, bidType, moreThanTender, auctionMode, auctionStageHasBid, biddingStage, auctionHighestDisplay, compareWithTenderDisplay, } = auctionInfo;
                // 如果有tradeCode，那么就请求车辆图片信息
                if (auctionId !== nowCarAuctionId && judgeEmptyStr(tradeCode)) {
                    dispatch.carImgs.getCarImgs({ reportCode: tradeCode, defaultImg: firstImage ? [{ photoPathSamll: firstImage }] : '' });
                }
                // 赋值操作：如值非undefined则赋值，否则展示原有值
                const temp = {
                    sessionId: id,
                    sessionStatus: 'begin',
                    carInfo: {
                        firstImage: firstImage === oldFirstImg ? undefined : firstImage,
                        carNum: dealCarNum(auctionSerialNumber),
                        carName,
                        type: carType,
                        license,
                        emission: emissionStandard,
                        address: locationName,
                        transmission: tranmission,
                        changeNum: transferCount,
                        mileage,
                        onDate: factoryDate,
                    },
                    isFormal: roundSimulateStatus === 0 ? true : false,
                    isTheLast: theLastCar,
                    beginPrice: auctionPriceW,
                    carResult: status,
                    countNum,
                    currentPrice: priorityOfferW,
                    answerPrice: priorityOfferW,
                    nowCarAuctionId: auctionId,
                    bidStatus,
                    countDownStatus: countDownStatus === 1,
                    finalOfferW,
                    brokerageW,
                    commissionW,
                    exceedBasePrice,
                    bidType,
                    moreThanTender,
                    nextCarNum: dealCarNum(nextAuctionSerialNumber),
                    nextCarName,
                    is268V: reportResultType === 1,
                    rank,
                    auctionMode,
                    auctionStageHasBid,
                    biddingStage,
                    auctionHighestDisplay,
                    compareWithTenderDisplay,
                };
                this.SET_STATE(Object.assign({}, clearObj(temp)));
                // 竞价倒计时
                if (status === 3 && (countDownStatus === 1)) {
                    this.goToCount({ countNum, type: 'duringAuction' });
                }
                // 应价倒计时
                if (status === 81 || status === 8) {
                    this.goToCount({ countNum, type: 'duringAnswer' });
                }
                // 车辆倒计时
                if (status === 5 || status === 50 || status === 51 || status === 6) {
                    this.goToCount({ countNum, type: 'duringEndCar' });
                }
                if (path.includes('auctioneer') || (path.includes('screen') && isListenLong)) {
                    // loop
                    if (status === 4 || status === 30 || status === 80) {
                        this.loop({});
                    }
                }
            });
        },
        /**
         * @desc 上车推送
         */
        upCar(payload, { update, state, rootState }) {
            const { roundId: id, auctionId, carInfo, auctionInfo } = payload, restData = __rest(payload, ["roundId", "auctionId", "carInfo", "auctionInfo"]);
            // 如果是同一个场次
            if (state.sessionId === id && state.nowCarAuctionId !== auctionId) {
                logColor('大屏收到上车推送了哦', payload, 'color: magenta');
                if (judgeObj(payload) && judgeObj(carInfo) && judgeObj(auctionInfo)) {
                    const _auctionInfo = Object.assign(Object.assign({}, auctionInfo), { countDownStatus: false, auctionId });
                    this.dealBegin(Object.assign({ id, carInfo, auctionInfo: _auctionInfo }, restData));
                }
            }
        },
        /**
         * @desc 结束拍卖
         */
        roundStatus(payload, { update, state, rootState }) {
            logColor('大屏收到场次状态变更推送了哦', payload, 'color: magenta');
            // 判断是否是场次变更为结束或撤销状态了，如果是，处理为已结束，如果不是，不care
            const { roundId, roundStatus } = payload;
            if (roundId && (roundStatus === 3 || roundStatus === 4)) {
                this.dealEnd({ id: roundId });
            }
        },
        /**
        * @desc 价格推送
        */
        price(payload, { update, state, rootState }) {
            logColor('大屏收到价格推送了哦', payload, 'color: magenta');
            const { priorityOfferW, countNum, countDownStatus, finalOfferW, brokerageW, status, exceedBasePrice, bidType, commissionW, moreThanTender, } = payload;
            // 赋值所有信息
            this.SET_STATE({
                currentPrice: priorityOfferW,
                carResult: status,
                bidStatus: true,
                auctionStageHasBid: true,
                countDownStatus: countDownStatus === 1,
                finalOfferW,
                brokerageW,
                exceedBasePrice,
                bidType,
                commissionW,
                moreThanTender,
            });
            // 如果处在倒计时阶段 进行倒计时
            if (status === 3 && countDownStatus === 1) {
                this.SET_STATE({ countNum });
                this.goToCount({ countNum, type: 'duringAuction' });
            }
            if (status === 30) {
                this.CLEAR__COUNT();
            }
        },
        /**
        * @desc 车结果推送
        */
        carResult(payload, { update, state, rootState }) {
            logColor('大屏收到车结果推送了哦', payload, 'color: magenta');
            const { status, countNum, exceedBasePrice, moreThanTender, priorityOfferW, finalOfferW, brokerageW, commissionW, bidType, biddingStage, } = payload;
            // 赋值所有信息 如没返回的字段则不赋值
            const dealTemp = {
                carResult: status,
                countNum,
                currentPrice: priorityOfferW,
                answerPrice: priorityOfferW,
                finalOfferW,
                brokerageW,
                commissionW,
                exceedBasePrice,
                moreThanTender,
                bidType,
                biddingStage,
            };
            this.SET_STATE(Object.assign({}, clearObj(dealTemp)));
            this.CLEAR__LOOP();
            this.goToCount({ countNum, type: 'duringEndCar' });
        },
        /**
         * @desc 开启倒计时
         */
        countDownStart(payload, { update, state, rootState }) {
            logColor('大屏收到开启倒计时推送了哦', payload, 'color: magenta');
            const { countNum, status } = payload;
            // 赋值所有信息
            this.SET_STATE({
                countDownStatus: true,
                countNum,
                carResult: status,
            });
            this.goToCount({ countNum, type: 'duringAuction' });
        },
        /**
         * @desc 暂停推送
         */
        countDownSuspended(payload, { update, state, rootState }) {
            logColor('大屏收到暂停推送了哦', payload, 'color: magenta');
            const { status, countNum } = payload;
            // 赋值所有信息
            this.SET_STATE({
                carResult: status,
                countNum,
            });
            this.loop({});
        },
        /**
         * @desc 暂停恢复
         */
        countDownRestore(payload, { update, state, rootState }) {
            logColor('大屏收到暂停恢复推送了哦', payload, 'color: magenta');
            const { status, countNum, type } = payload;
            // 赋值所有信息
            this.SET_STATE({
                carResult: status,
                countNum,
                countDownStatus: type !== 1,
            });
            this.CLEAR__LOOP();
            if (type !== 1) {
                const _type = type === 3 ? 'duringAnswer' : 'duringAuction'; // type： 1 暂停拍卖 2 竞拍中 3 应价
                this.goToCount({ countNum, type: _type });
            }
        },
        /**
         * @desc 应价推送
         */
        biddingPrice(payload, { update, state, rootState }) {
            logColor('大屏收到应价推送了哦', payload, 'color: magenta');
            const { status, priorityOfferW, countNum, finalOfferW, brokerageW, commissionW } = payload;
            // 赋值所有信息
            this.SET_STATE({
                carResult: status,
                answerPrice: priorityOfferW,
                countNum,
                finalOfferW,
                brokerageW,
                commissionW,
            });
            this.goToCount({ countNum, type: 'duringAnswer' });
        },
        /**
         * @desc 竞拍结束推送
         */
        auctionStatus(payload, { update, state, rootState }) {
            logColor('大屏收到竞拍结束推送了哦', payload, 'color: magenta');
            const { status } = payload;
            // 赋值所有信息
            this.SET_STATE({
                carResult: status,
            });
            // 轮询
            this.loop({});
        },
        /**
         * @desc 主动获取车辆是否结束接口
         * @argument 轮询场景 倒计时计时结束 | 开始应价 | 拍卖暂停 | 应价暂停 | 车辆有竞拍结果
         * @argument 轮询时长 1s
         */
        loop(payload, { update, state, rootState }) {
            this.CLEAR__LOOP();
            this.loopFunction({});
            const _loop = setInterval(() => __awaiter(this, void 0, void 0, function* () {
                this.loopFunction({});
            }), 1000);
            this.SET__LOOP(_loop);
        },
        /**
         * @desc 轮询函数
         */
        loopFunction(payload, { update, state, rootState }) {
            const { nowCarAuctionId, carResult: fromCarResult, sessionId, isFormal } = state;
            const _param = {
                roundId: sessionId,
                auctionId: nowCarAuctionId,
                stopThisAuction: 0,
            };
            Api.auction.hasEndOfTheAuction(_param).then((_r) => {
                // console.log('大屏结束接口返回_r', _r);
                // console.log('fromCarResult', fromCarResult);
                const data = JSON.parse(JSON.stringify(_r));
                if (judgeObj(data)) {
                    if (data.roundStatus === 3) {
                        this.dealEnd({ id: sessionId });
                        return;
                    }
                    if (judgeObj(data.auctionInfo)) {
                        const { auctionInfo } = data;
                        const { auctionId, roundSimulateStatus } = auctionInfo;
                        // 场次变更 || 车辆变更 重新请求接口
                        const _isFormal = (roundSimulateStatus === 0) === isFormal;
                        if (!_isFormal || nowCarAuctionId !== auctionId) {
                            this.CLEAR__LOOP();
                            this.load({});
                        }
                        // 状态变更 更新详情
                        const { status, priorityOfferW, countNum, countDownStatus, bidStatus, exceedBasePrice, moreThanTender, auctionStageHasBid, finalOfferW, brokerageW, commissionW, } = auctionInfo;
                        if (fromCarResult !== status) {
                            this.CLEAR__LOOP();
                            const dealTemp = {
                                countNum,
                                countDownStatus: countDownStatus === 1,
                                carResult: status,
                                currentPrice: priorityOfferW,
                                answerPrice: priorityOfferW,
                                bidStatus,
                                exceedBasePrice,
                                moreThanTender,
                                auctionStageHasBid,
                                finalOfferW,
                                brokerageW,
                                commissionW,
                            };
                            this.SET_STATE(Object.assign({}, clearObj(dealTemp)));
                            // 竞价倒计时
                            if (status === 3 && (countDownStatus === 1)) {
                                this.goToCount({ countNum, type: 'duringAuction' });
                                return;
                            }
                            // 应价倒计时
                            if (status === 81 || status === 8) {
                                this.goToCount({ countNum, type: 'duringAnswer' });
                                return;
                            }
                            // 车辆倒计时
                            if (status === 5 || status === 50 || status === 51 || status === 6) {
                                this.goToCount({ countNum, type: 'duringEndCar' });
                                return;
                            }
                            // loop
                            if (status === 4 || status === 30 || status === 80) {
                                this.loop({});
                                return;
                            }
                        }
                    }
                }
            });
        },
        /**
         * @desc 主动倒计时
         * @argument 所有倒计时均自己倒计时
         * @argument 时长 1s
         */
        countDown(payload, { update, state, rootState }) {
            const { path } = rootState.router;
            this.CLEAR__COUNT();
            let { num } = payload;
            const _count = setInterval(() => {
                if (num > 1) {
                    num -= 1;
                    this.SET_COUNTNUM(num);
                }
                else {
                    this.CLEAR__COUNT();
                    if (path.includes('auctioneer') || (path.includes('screen') && isListenLong)) {
                        // loop
                        this.loop({});
                    }
                }
            }, 1000);
            this.SET__COUNT(_count);
        },
        /**
         * @desc 进入倒计时
         */
        goToCount(payload) {
            const { countNum, type } = payload;
            if (countNum > 0) {
                this.countDown({ num: countNum });
            }
            else if (type && countNum < 0) {
                let _msg;
                switch (type) {
                    case 'duringAuction':
                        _msg = '竞拍倒计时，服务端返回秒数不正确';
                        break;
                    case 'duringAnswer':
                        _msg = '应价倒计时，服务端返回秒数不正确';
                        break;
                    case 'duringEndCar':
                        _msg = '下一辆车倒计时，服务端返回秒数不正确';
                        break;
                }
                notification.error({
                    message: _msg,
                });
            }
        },
    },
    reducers: {
        RESET_STATE() {
            return Object.assign({}, initState);
        },
        RESET_STATE2() {
            return Object.assign(Object.assign({}, initState), { sessionStatus: 'begin' });
        },
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (initState[key] !== undefined) {
                    state[key] = payload[key];
                }
            });
        },
        SET__COUNT(state, payload) {
            state._count = payload;
        },
        CLEAR__COUNT(state) {
            clearInterval(state._count);
            state._count = 0;
        },
        SET__LOOP(state, payload) {
            state._loop = payload;
        },
        CLEAR__LOOP(state) {
            clearInterval(state._loop);
            state._loop = 0;
        },
        SET_COUNTNUM(state, payload) {
            state.countNum = payload;
        },
    },
});
